import request from '@/utils/request'

// 商户登录
export function login(data) {
  return request({
    url: '/v2/promotion/merchant/login',
    method: 'post',
    data
  })
}

// 商户推广码列表
export function getPromotionCodes(params) {
  return request({
    url: '/v2/promotion/merchant/promotion-codes',
    method: 'get',
    params
  })
}

// 商户佣金列表
export function getCommisionOrders(data) {
  return request({
    url: '/v2/promotion/merchant/commision-orders',
    method: 'post',
    data
  })
}

// 商户佣金总览
export function getCommisionSummary(data) {
  return request({
    url: '/v2/promotion/merchant/commision-summary',
    method: 'post',
    data
  })
}

// 商品列表
export function getProducts() {
  return request({
    url: '/v2/promotion/products',
    method: 'get',
  })
}